module.exports = __webpack_public_path__ + "static/media/addUpdate.20d07b20.jpg";